<template>
  <div id="app">
    <div class="navbar navbar-default navbar-static-top">
        <div class="container">
          <div class="navbar-header">
              <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar"
                aria-expanded="false" aria-controls="navbar">
              <span class="sr-only">Toggle navigation</span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              </button>
              <a class="navbar-brand" href="#"><img src="./assets/img/logo-unilink.png" /></a>
          </div>
          <div id="navbar" class="navbar-collapse collapse">
              <ul class="nav navbar-nav">
                <router-link tag="li" :to="{ name:'rfq' }"><a>RFQ</a></router-link>
                <router-link tag="li" :to="{ name:'expressquote' }"><a>QUOTE</a></router-link>
                <router-link tag="li" :to="{ name:'checkouterp' }"><a>ERP</a></router-link>
                <router-link tag="li" :to="{ name: 'cat4mro.search' }"><a>CAT4MRO</a></router-link>
                <router-link tag="li" :to="{ name: 'catalog' }"><a>CATÁLOGO</a></router-link>
              </ul>
              <ul class="nav navbar-nav navbar-right">
                <li>
                  <router-link v-if="counterInfo > 0" to="/shoppingcart">
                    <span class="glyphicon glyphicon-shopping-cart"></span>
                    <span class="label label-danger"> {{counterInfo}}</span>
                  </router-link>
                </li>
                <li class="dropdown">
                    <a href="#" class="dropdown-toggle" data-toggle="dropdown"
                     role="button" aria-haspopup="true" aria-expanded="false">
                     Francisco G. <span class="caret"></span></a>
                    <ul class="dropdown-menu">
                      <li><a href="#">Change Password</a></li>
                      <li><a href="#">Logout</a></li>
                    </ul>
                </li>
              </ul>
          </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <breadcrumbs/>
          </div>
        </div>
        <div class="row m20top">
           <router-view/>
        </div>
    </div>
    <footer>
        <div class="footer">
          <div class="container">
              <div class="row">
                <div class="col-xs-12">
                    <p>© Unilink Solutions</p>
                </div>
              </div>
          </div>
        </div>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'App',
  computed: {
    ...mapGetters([
      'counterInfo',
    ]),
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue